import React, { useState, useEffect } from 'react';
import { NumberInputTypeV2, NumberInputV2 } from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { NumericFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface FormNumberInputV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    NumberInputTypeV2 {
  fieldMeta: NumericFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormNumberInputV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormNumberInputV2Props<TFormFields>) => {
  const [isReadOnly, setIsReadOnly] = useState(readOnly);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsReadOnly(false);
    }, 650);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <NumberInputV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          readOnly={isReadOnly}
          max={fieldMeta.fieldOptions.max}
          min={fieldMeta.fieldOptions.min}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
